import React from 'react';
import {
  FormDialog,
  IMAGE_FILE_ACCEPT,
  RhfFileInput,
  toast,
} from '@core/components';
import type { Vestment } from '../../api/vestment';
import { updateVestment } from '../../api/vestment';
import { getImageThumbnailUrl } from '../utils/image';
import { getVestmentTypeLabel } from '../utils/vestment';

interface VestmentDialogProps {
  open: boolean;
  onClose: () => void;
  vestment: Vestment;
  onSuccess?: () => void;
}

type VestmentImageFormValues = {
  image: File | null;
};

const defaultValues: VestmentImageFormValues = {
  image: null,
};

const VestmentDialog: React.FC<VestmentDialogProps> = ({
  open,
  onClose,
  vestment,
  onSuccess,
}) => {
  const onSubmit = async (data: VestmentImageFormValues) => {
    if (!data.image) {
      return;
    }
    try {
      await updateVestment(vestment.id, { image: data.image });
      toast.success('Image updated');
      onSuccess?.();
    } catch (error) {
      toast.apiError('Failed to update image.', error);
      throw error;
    }
  };

  return (
    <FormDialog<VestmentImageFormValues>
      open={open}
      onClose={onClose}
      title={`Edit ${getVestmentTypeLabel(vestment.type)}`}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      submitText="Update"
      maxWidth="xs"
    >
      <RhfFileInput<VestmentImageFormValues>
        name="image"
        label="Image"
        accept={IMAGE_FILE_ACCEPT}
        initialPreviewSrc={getImageThumbnailUrl(vestment)}
      />
    </FormDialog>
  );
};

export default VestmentDialog;
